import React from 'react';
import { createRoot } from 'react-dom/client';
import { registerLicense } from '@syncfusion/ej2-base';
import App from './App';
import { ContextProvider } from './contexts/ContextProvider';
import './index.css';

const license = process.env.REACT_APP_SYNCFUSION_LICENSE_KY;
if (license) registerLicense(license);

const root = createRoot(document.getElementById('root'));
root.render(
  <ContextProvider>
    <App />
  </ContextProvider>,
);
